<template>
    <div :class="[{'focused-item':focused}, 'merge-button-container']">

        <el-tooltip placement="top-start"
                    :content="megreTooltip"
                    :show-after="5">
            <div id="split-button"
                 class="img-button-container merge-button"
                 @click="splitSegment">
                <span class="material-symbols-outlined">
                    expand
                </span>
            </div>
        </el-tooltip>

    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { shortcuts } from '@/utils/shortcuts';

    export default defineComponent({
        props: {
            focused: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                megreTooltip: shortcuts.getTooltipTranslated(this.$t, shortcuts.split),
            }
        },
        methods: {
            splitSegment() {
                this.$emit('split');
            }
        }

    });
</script>

<style lang="scss" scoped>

    .merge-button-container {
        height: 1px;
        width: 30%;
        position: absolute;
        opacity: 0;
        transition: opacity 0.5s ease;

        &:hover {
            opacity: 0.6;
        }
    }

    .focused-item.merge-button-container {
        opacity: 1;
    }

    .merge-button {
        position: absolute;
        top: -24px;
        left: 65px;
        background-color: white;
        border-radius: 24px;
        box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.1);
    }
</style>